var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "#A1A1A1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53906 6.5L13.3828 11.3438C13.5 11.4609 13.5 11.6562 13.3828 11.8125L12.5234 12.6719C12.3672 12.7891 12.1719 12.7891 12.0547 12.6719L11.2344 11.8516L7.25 7.82812L2.40625 12.6719C2.28906 12.7891 2.09375 12.7891 1.9375 12.6719L1.07812 11.8125C0.960938 11.6562 0.960938 11.4609 1.07812 11.3438L5.92188 6.5L1.07812 1.69531C0.960938 1.57812 0.960938 1.38281 1.07812 1.22656L1.9375 0.367188C2.09375 0.25 2.28906 0.25 2.40625 0.367188L7.25 5.21094L12.0547 0.367188C12.1719 0.25 12.3672 0.25 12.5234 0.367188L13.3828 1.22656C13.5 1.38281 13.5 1.57812 13.3828 1.69531L12.5625 2.51562L8.53906 6.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.6e58d8ae.svg";
export { ForwardRef as ReactComponent };